// The question banks. They used to be compiled into the app's JavaScript, which anyone could download; now they are
// JSON files under /banks/ that only a signed-in account may fetch (proxy.js), loaded once after sign-in.
//
// The arrays and the QB object keep their identity: loadBanks() fills them in place, so code that captured a reference
// before the load (practice pools, exam restore) reads the questions as soon as they arrive.
export const BANKS = {
  QB: {},            // NAPLAN, keyed by subject
  ALL: [],           // the inline NAPLAN bank
  EXAM: [],          // Selective, OC, ACER, ICAS, VIC Selective
  naplan: { y3: [], y5: [], y7: [], y9: [] },
  interactive: [],   // ExamInteractive's bank (drag-drop, hot text and the other primitives)
};

const FILES = {
  'QB': '/banks/qb.json', 'ALL': '/banks/all.json', 'EXAM': '/banks/exam.json',
  'naplan.y3': '/banks/naplan-y3.json', 'naplan.y5': '/banks/naplan-y5.json', 'naplan.y7': '/banks/naplan-y7.json', 'naplan.y9': '/banks/naplan-y9.json',
  'interactive': '/banks/interactive.json',
};

function target(key) { return key.split('.').reduce((o, k) => o[k], BANKS); }
function fill(key, data) {
  const t = target(key);
  if (Array.isArray(t)) { t.length = 0; for (let i = 0; i < data.length; i++) t.push(data[i]); }
  else { for (const k of Object.keys(t)) delete t[k]; Object.assign(t, data); }
}

let pending = null;
export const banksLoaded = () => BANKS.ALL.length > 0;

/** Fetches every bank (same-origin, so the session cookie goes with it). Safe to call many times. */
export function loadBanks(fetchFn = typeof fetch === 'function' ? fetch : null) {
  if (banksLoaded()) return Promise.resolve();
  if (!pending) {
    pending = Promise.all(Object.entries(FILES).map(async ([key, url]) => {
      const r = await fetchFn(url, { credentials: 'same-origin' });
      if (!r.ok) throw new Error(`${url}: ${r.status}`);
      fill(key, await r.json());
    })).catch((e) => { pending = null; throw e; });
  }
  return pending;
}

/** Tests and sign-out: back to empty. */
export function resetBanks() { for (const key of Object.keys(FILES)) fill(key, Array.isArray(target(key)) ? [] : {}); pending = null; }
